import React, {Fragment} from 'react';
import styled from "styled-components";
import CheckIcon from '@material-ui/icons/Check';
import {Grid} from '@material-ui/core';

const Unselected = styled.div`
& {
  align-items:center;
  background:#f5f5f5;
  display:flex;
  font-size:17px;
  justify-content:flex-start;  
  min-height:20px;
  height:calc(100% - 16px);
  padding:8px;
  text-align:left;
  transition: 0.3s background, 0.3s color, 0.3s border;
}
&:hover {
  background:#f9f9f9;
  cursor:pointer    
}
`;
const Selected = styled(Unselected)`
  & {
    background: #2196f3;
    color:#fff;
  }
  &.selected {    
    background: #2196f3;
    color:white;            
  }
  &:hover {
    background:#43A8FF;
    cursor:pointer    
  }
`;
const Spacer = styled.div`
  flex-grow:1;
`
class ModalLoanItem extends React.Component {    

  renderElement = (loan) => {
    if(this.props.isSelected)
      return this.renderSelected(loan.title, loan.id);
    return this.renderUnselected(loan.title, loan.id);
  }

  renderSelected = (title, id) => {
    const {toggle} = this.props;
    return (
      <Selected onClick={() => toggle(id)}>
        <div>{title}</div>      
        <Spacer/>            
        <CheckIcon/>
      </Selected>
    )
  }

  renderUnselected = (title, id) => {
    const {toggle} = this.props;
    return (
      <Unselected onClick={() => toggle(id)}>
        {title}
      </Unselected>
    )
  }
  
  render() {
    const { loan} = this.props;    
    return (                      
          <Grid item xs={6}>
            {this.renderElement(loan)}
          </Grid>      
    );
  }
}

export default ModalLoanItem;
